import { createBrowserRouter } from "react-router-dom"
import { lazy, Suspense } from "react"
import Layout from "@/components/layout/Layout"
import ErrorBoundary from "@/components/ErrorBoundary/ErrorBoundary"
import { replaceTo, setRouterInstance } from "@/utils/navigation"
import shiliangRouter from "./shiliang"
import creditSaleRouter from "@/subCreditSale/router"
import codeFruitRouter from "@/subCodeFruit/router"

// 使用懒加载避免循环依赖
const Register = lazy(() => import("@/pages/register/Register"))
const Apply = lazy(() => import("@/pages/apply/Apply"))
const ApplyApiProduct = lazy(() => import("@/pages/applyApiProduct/ApplyApiProduct"))
const Download = lazy(() => import("@/pages/download/Download"))
const Quota = lazy(() => import("@/pages/quota/Quota"))
const CustomerService = lazy(() => import("@/pages/customerService/CustomerService"))
const Agreement = lazy(() => import("@/pages/common/agreement/Agreement")) // 通用查看协议
const Gateway = lazy(() => import("@/pages/gateway/Gateway"))
const Prefilter = lazy(() => import("@/pages/prefilter/PrefilterPage")) // 前筛预审
const GuideStream = lazy(() => import("@/pages/guideStream/GuideStream")) // 导流页面


// 404 页面组件
const NotFound = () => {
  return (
    <div className="not-found">
      <h1>404</h1>
      <p>页面不存在</p>
      <a href="/register">返回首页</a>
    </div>
  )
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: (
          <ErrorBoundary>
            <Suspense fallback={<div>Loading...</div>}>
              <Register />
            </Suspense>
          </ErrorBoundary>
        ),
      },
      {
        path: "register", // 注册页
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Register />
          </Suspense>
        ),
      },
      {
        path: "gqs-register", // 注册页
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Register />
          </Suspense>
        ),
      },
      {
        path: "gqs-apply", // 拒量
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Apply />
          </Suspense>
        ),
      },
      {
        path: "gqs-applyApiProduct", // 拒量
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <ApplyApiProduct />
          </Suspense>
        ),
      },
      {
        path: "gqs-download", // app下载页
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Download />
          </Suspense>
        ),
      },
      {
        path: "gqs-quota", // 领取额度页
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Quota />
          </Suspense>
        ),
      },
      {
        path: "customerService", // 客服页
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <CustomerService />
          </Suspense>
        )
      },


      {
        path: "agreement", // 协议
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Agreement />
          </Suspense>
        ),
      },

      {
        path: "gateway", // 外部统一入口
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Gateway />
          </Suspense>
        ),
      },

      ...shiliangRouter, // 信贷分期
      
      {
        path: "creditSale", // 赊销流程
        children: [
          ...creditSaleRouter,
        ]
      },

      {
        path: "prefilter", // 前筛预审
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <Prefilter />
          </Suspense>
        ),
      },

      {
        path: "guideStream", // 前筛预审
        element: (
          <Suspense fallback={<div>Loading...</div>}>
            <GuideStream />
          </Suspense>
        ),
      },
      // 码果相关页面
      {
        path: "codeFruit",
        children: [
          ...codeFruitRouter,
        ],
      },

    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
])

// 设置 router 实例供导航工具使用
setRouterInstance(router)

const PAGES_LIST = [
  '/gqs-quota', // 领取额度页面
  // '/three-auth-ocr', // 三要素认证页面（身份证上传）
  // '/complete-result', // 三要素认证结果页面
  // '/gqs-face', // 签章结果页面
]

let currentPath = ''

router.subscribe((state) => {
  if (state.historyAction === 'PUSH') {
    currentPath = state.location.pathname
  }
  
  if (state.historyAction === 'POP') {
    if (PAGES_LIST.includes(currentPath)){
    console.log('【credit-H5 返回上一页拒量导流】')
    replaceTo(`/gqs-apply?status=FAIL&from=${currentPath.replace('/', '')}`)
    }else{
      currentPath = state.location.pathname
    }
  }
})